/**
 * Data Layer - 统一出口 + 本地化修正
 *
 * 三步管道:
 *   1) 从 contentData.js 拿原始 POSTS 快照
 *   2) 用 coverManifest 修正 coverUrl(本地文件优先,丢弃飞书死链)
 *   3) 用 bookCovers 兜底(目前 URL 已清空,通常走到 placeholder)
 *
 * 业务代码只从此文件导入 POSTS / DATA_META,无需关心数据修正细节。
 */
import { DATA_META, RAW_POSTS, POSTS as PARTIAL_POSTS } from './contentData.jsx';
import { BOOK_COVERS, getBookCover } from './bookCovers.js';
import { COVER_FILE_SET } from './coverManifest.js';

/**
 * 本地化 coverUrl 修正:
 *   - 若 post 声明了 coverImageFile 且文件真实存在 -> assets/covers/<filename>
 *   - 否则 fallback 到 getBookCover(本地 URL,目前几乎不会命中)
 *   - 都没有 -> '' (UI 会用占位图)
 */
function localEnrich(post) {
  const filename = post.coverImageFile;
  const hasFile = filename && COVER_FILE_SET.has(filename);
  let coverUrl = '';
  if (hasFile) {
    coverUrl = `assets/covers/${filename}`;
  } else {
    coverUrl = getBookCover(post.book) || '';
  }

  // 同样的逻辑应用在 versions 内
  const versions = post.versions || {};
  const newVersions = {};
  for (const ver of Object.keys(versions)) {
    const v = versions[ver];
    const vFile = v.coverImageFile;
    const vHas = vFile && COVER_FILE_SET.has(vFile);
    const vUrl = vHas ? `assets/covers/${vFile}` : coverUrl;
    newVersions[ver] = { ...v, coverUrl: vUrl };
  }

  return {
    ...post,
    coverUrl,
    coverExists: hasFile,
    versions: newVersions,
  };
}

export const POSTS = PARTIAL_POSTS.map(localEnrich);

export { DATA_META, BOOK_COVERS, getBookCover };
